import { Field, NumberEditor } from '@approvalmax/ui';
import { domain } from 'modules/data';
import { memo } from 'react';

import { messages } from './AmountSearchFields.messages';
import { AmountFieldRow, AmountRow, AmountRowNote } from './AmountSearchFields.styles';
import { AmountSearchFieldsProps } from './AmountSearchFields.types';

export const AmountSearchFields = memo<AmountSearchFieldsProps>((props) => {
    const { company, integrationCode, params, updateParameter, disabled } = props;

    const isVendorOrContact =
        integrationCode === domain.IntegrationCode.QBooksVendor ||
        integrationCode === domain.IntegrationCode.XeroContact;

    return (
        <AmountRow>
            <Field
                title={messages.amountFieldTitle({
                    currency: company?.defaultCurrency,
                })}
            >
                <AmountFieldRow>
                    <div>{messages.amountFromText}</div>

                    <NumberEditor
                        placeholder={messages.amountGreaterEqualsPlaceholder}
                        value={params.amountGreaterEquals}
                        disabled={disabled || isVendorOrContact}
                        onChange={updateParameter('amountGreaterEquals')}
                    />

                    <div>{messages.amountToText}</div>

                    <NumberEditor
                        placeholder={messages.amountLessEqualsPlaceholder}
                        disabled={disabled || isVendorOrContact}
                        value={params.amountLessEquals}
                        onChange={updateParameter('amountLessEquals')}
                    />
                </AmountFieldRow>
            </Field>

            <AmountRowNote>{messages.amountRowNote}</AmountRowNote>
        </AmountRow>
    );
});

AmountSearchFields.displayName = 'AmountSearchFields';
